/**
 * 학습지 제작 FAQ 데이터
 */

export const worksheetFaq = [
  {
    id: 'worksheet-001',
    category: 'worksheet',
    question: '어떤 종류의 학습지를 만들 수 있나요?',
    answer: `
      <h3>채팅에서 만드는 학습지</h3>
      <p>/chat에서 학습지 종류를 고르고, 과목과 형태를 적어 주세요.</p>
      <ul>
        <li>객관식, 서술형, 빈칸 채우기, OX</li>
        <li>형성평가, 단원평가</li>
        <li>수행평가와 루브릭</li>
      </ul>
      <p>무료는 텍스트 학습지예요. 이미지로 받아 인쇄하려면 PRO가 필요해요.</p>

      <h4>만드는 순서</h4>
      <ol>
        <li>/chat에서 학습지를 골라요.</li>
        <li>학년·과목·문제 수·난이도를 적어요.</li>
        <li>결과를 보고 수정해 달라고 해요.</li>
      </ol>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>요청을 더 짧게, 구체적으로 다시 보내요.</li>
        <li>교과서 내용을 쓰려면 참고 자료함에 텍스트를 넣어요.</li>
        <li>파일로 올리려면 PRO가 필요해요.</li>
      </ul>
    `,
    tags: ['학습지 종류', '자유형 시험지', '수행평가', '학습지 생성'],
    relatedFaqs: ['worksheet-002', 'worksheet-003', 'getting-started-001'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 학습지 종류',
    seoDescription: '객관식·서술형·수행평가 학습지를 채팅에서 만드는 방법과 무료·PRO 차이를 안내합니다.'
  },

  {
    id: 'worksheet-002',
    category: 'worksheet',
    question: '좋은 학습지를 만들기 위한 팁이나 요령이 있나요?',
    answer: `
      <h3>요청을 구체적으로</h3>
      <p>학년, 단원, 유형, 문제 수를 함께 적으면 결과가 안정적이에요.</p>
      <ul>
        <li>덜 좋은 예: "중학교 수학 문제"</li>
        <li>좋은 예: "중2 일차함수 기울기 객관식 8개, 난이도 중"</li>
      </ul>

      <h4>학년별 힌트</h4>
      <ul>
        <li>초등: 짧은 문제, 생활 속 상황</li>
        <li>중등: 개념 확인 + 적용을 섞어요</li>
        <li>고등: 시간·배점을 함께 적어요</li>
      </ul>

      <h4>잘 안 맞을 때</h4>
      <ul>
        <li>"더 쉽게" 또는 "서술형으로"처럼 한 가지만 고쳐 달라고 해요.</li>
        <li>우리 반 기준이 있으면 참고 자료함에 붙여 넣어요.</li>
        <li>만든 뒤에는 학습 목표와 난이도를 한 번 더 확인해요.</li>
      </ul>
    `,
    tags: ['학습지 제작 팁', '효과적인 문제', '난이도 조절', '학년별 전략', '품질 향상'],
    relatedFaqs: ['worksheet-001', 'worksheet-003', 'worksheet-004'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 학습지 요청 방법',
    seoDescription: '학년·단원·유형을 구체적으로 적어 학습지 품질을 맞추는 방법을 안내합니다.'
  },

  {
    id: 'worksheet-003',
    category: 'worksheet',
    question: 'HWP나 워드 파일로 변환할 때 주의사항이 있나요?',
    answer: `
      <h3>한글 양식과 학습지 저장</h3>
      <p>학습지는 텍스트로 받거나, PRO에서 이미지로 받아 인쇄해요.</p>
      <p>학교 한글 양식을 채울 때는 채팅에서 한글 작성을 고르고 파일을 올려요. 파일 첨부는 PRO예요.</p>

      <h4>받은 뒤 확인할 점</h4>
      <ul>
        <li>수식과 표가 깨졌는지 봐요.</li>
        <li>여백과 글자 크기를 학교에 맞게 고쳐요.</li>
        <li>인쇄 미리보기로 한 장씩 확인해요.</li>
      </ul>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>한글 파일이 안 열리면 채팅에서 다시 내려받아요.</li>
        <li>수식이 깨지면 해당 부분만 다시 적어 달라고 해요.</li>
        <li>업로드가 안 되면 파일 크기와 인터넷을 확인해요.</li>
      </ul>
    `,
    tags: ['HWP 변환', '워드 변환', '문서 호환성', '레이아웃 조정', '파일 형식'],
    relatedFaqs: ['worksheet-002', 'features-008', 'payment-001'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 한글·학습지 저장 안내',
    seoDescription: '학습지 텍스트·이미지 저장과 PRO 한글 양식 첨부 시 확인할 점을 안내합니다.'
  },

  {
    id: 'worksheet-004',
    category: 'worksheet',
    question: 'PDF 파일을 업로드해서 비슷한 문제를 만들 수 있나요?',
    answer: `
      <h3>파일로 비슷한 문제 만들기</h3>
      <p>교과서나 기출 PDF를 올리면, 그 내용을 참고해 문제를 만들 수 있어요. 파일 첨부는 PRO예요.</p>
      <p>무료는 <a href="/chat/settings">참고 자료함</a>에 텍스트 3개까지 넣을 수 있어요.</p>

      <h4>순서</h4>
      <ol>
        <li>PRO 계정으로 /chat에 들어가요.</li>
        <li>학습지를 고르고 파일을 첨부해요.</li>
        <li>원하는 변형을 적어요. 예: "숫자만 바꾼 객관식 10개"</li>
      </ol>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>글자가 흐리면 더 선명한 파일로 올려요.</li>
        <li>페이지가 많으면 필요한 페이지만 올려요.</li>
        <li>파일이 크면 나눠서 올려요.</li>
        <li>무료 계정은 핵심 지문을 텍스트로 붙여 넣어요.</li>
      </ul>
    `,
    tags: ['PDF 업로드', '문제 분석', '유사 문제 생성', '기출문제 변형', '파일 업로드'],
    relatedFaqs: ['features-012', 'worksheet-002', 'worksheet-001'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 PDF로 유사 문제 만들기',
    seoDescription: 'PRO 파일 첨부와 무료 텍스트 참고 자료로 기존 문제를 변형하는 방법을 안내합니다.'
  },

  {
    id: 'worksheet-005',
    category: 'worksheet',
    question: '학생들과 공유하는 방법이 있나요? 링크로 배포할 수 있나요?',
    answer: `
      <h3>학습지 나누기</h3>
      <p>만든 학습지를 받거나 복사한 뒤, 클래스룸·메신저·이메일로 보내면 돼요.</p>
      <ul>
        <li>텍스트는 복사해서 붙여 넣어요.</li>
        <li>인쇄용은 PRO 이미지 학습지로 받아 보내요.</li>
      </ul>
      <p>학생 접속 통계나 비밀번호 링크 기능은 없어요.</p>

      <h4>보낼 때</h4>
      <ul>
        <li>학생 이름·성적은 넣지 않아요.</li>
        <li>교과서 내용을 그대로 올리지 않도록 확인해요.</li>
      </ul>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>파일이 안 받아지면 채팅에서 다시 저장해요.</li>
        <li>이미지가 흐리면 컴퓨터에서 다시 받아 봐요.</li>
        <li>반 전체에 보낼 때는 파일로 올리는 편이 안정적이에요.</li>
      </ul>
    `,
    tags: ['학습지 공유', '링크 배포', '학생 접근', '디지털 수업'],
    relatedFaqs: ['worksheet-001', 'getting-started-004', 'technical-001'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 학습지 공유 방법',
    seoDescription: '학습지를 받아 클래스룸이나 메신저로 보내는 방법과 개인정보 주의사항을 안내합니다.'
  }
];

// FAQ 검색 함수
export const searchWorksheetFaq = (query) => {
  const searchTerm = query.toLowerCase();
  return worksheetFaq.filter(faq => 
    faq.question.toLowerCase().includes(searchTerm) ||
    faq.answer.toLowerCase().includes(searchTerm) ||
    faq.tags.some(tag => tag.toLowerCase().includes(searchTerm))
  );
};

// ID로 FAQ 찾기
export const getWorksheetFaqById = (id) => {
  return worksheetFaq.find(faq => faq.id === id);
};

// 연관 FAQ 가져오기
export const getRelatedWorksheetFaqs = (currentFaqId) => {
  const currentFaq = getWorksheetFaqById(currentFaqId);
  if (!currentFaq || !currentFaq.relatedFaqs) return [];
  
  return currentFaq.relatedFaqs.map(id => getWorksheetFaqById(id)).filter(Boolean);
};
